async function testDelay(delay: number = 100): Promise<void> {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default testDelay;
